
import { apiClient } from '@/lib/mockApi';


export const useCadastrosOptions = () => apiClient;
